<template>
  <div class="bg-white">
    <div class="d-flex align-items-center bg-light p-3 mb-3 border-bottom">
      <BackButton :go="id ? -2 : -1" class="ml-n3" />
      <h4 class="m-0 text-truncate" :title="title">{{title}}</h4>
      <CancelButton class="ml-auto"/>
    </div>

    <ErrorDisplay :value="error" class="m-3"/>

    <OptionsFormRaw
      v-if="$store.state.preferences.showRaw"
      class="px-3"
      :set-item="setItem"
      :api="type"
      :value="item"
      :id-key="idKey"
      @success="onSuccess"
    >
      <template #default="{busy, disabled}">
        <slot name="submit" :busy="busy" :disabled="disabled"/>
      </template>
      <template #button-content>Save</template>
    </OptionsFormRaw>
    <OptionsFormApi
      v-else
      ref="form"
      class="px-3"
      :get-fields="getFields"
      :set-item="setItem"
      :api="type"
      :value="item"
      :omit-fields="omitFields ?? $store.getters['preferences/omitFields']"
      :modify-errors="modifyErrors"
      :modify-fields="modifyFields"
      :modify-request="modifyRequest"
      :id-key="idKey"
      @success="onSuccess"
    >
      <template #default="{busy, disabled}">
        <slot name="submit" :busy="busy" :disabled="disabled"/>
      </template>
      <template #button-content>Save</template>
    </OptionsFormApi>

    <ShowFields/>
  </div>
</template>

<script>
import BackButton from '@/components/BackButton.vue'
import CancelButton from '@/components/CancelButton.vue'
import OptionsFormApi from '@/components/OptionsFormApi.vue'
import OptionsFormRaw from '@/components/OptionsFormRaw.vue'
import ShowFields from '@/components/ShowFields.vue'
import { typeTitle } from '@/pages/_type/index.vue'
import { http } from '@/services/http.js'

export default {
  name: 'ManageItemEdit',
  components: {
    OptionsFormApi,
    OptionsFormRaw,
    BackButton,
    CancelButton,
    ShowFields,
  },
  props: {
    type: String,
    id: String,
    idKey: {
      type: String,
      default: 'id',
    },
    nameKey: {
      type: String,
      default: 'name',
    },
    getItem: {
      type: Function,
      default() {
        return http.get(`api/${this.type}/${this.id}/`)
          .then(response => response.data)
      },
    },
    setItem: null,
    getFields: null,
    omitFields: null,
    modifyErrors: Function,
    modifyFields: Function,
    modifyRequest: Function,
  },
  data() {
    return {
      error: null,
      item: null,
    }
  },
  computed: {
    title() {
      return (this.id)
        ? this.item?.[this.nameKey]
        : `New ${typeTitle(this.type)}`
    },
  },
  async created() {
    if (this.id) {
      this.item = {} // prevent flash of initial values
      this.item = await this.getItem()
        .catch(err => {
          this.error = err
          throw err
        })
    }
    await this.$nextTick()
    document.title = `${this.title} - Great American Art`
  },
  methods: {
    onSuccess(data) {
      if (this.id) {
        return history.back()
      }
      const type = this.$route.path.match(/manage\/([^/]*)/)[1]
      const id = this.id || data?.[this.idKey] || ''
      this.$router.replace({path: `/manage/${type}/${id}`})
    },
  },
}
</script>
